import { TFunction } from 'i18next';

import { Values } from '../../types';

export const HistoricalDataInterval = {
  Min15: 15 * 60,
  Min30: 30 * 60,
  Hour1: 60 * 60,
} as const;

export type HistoricalDataIntervalType = Values<typeof HistoricalDataInterval>;

export const historicalDataIntervalToOptions = (t: TFunction) =>
  // Numeric enums generate doubled properties, see https://blog.logrocket.com/why-typescript-enums-suck/
  Object.values(HistoricalDataInterval).reduce((options, interval) => {
    if (typeof interval !== 'number') {
      return options;
    }

    const option = {
      id: interval,
      name: t(`dataImport.historicalDataInterval.${interval}`),
    };

    return [...options, option];
  }, [] as { id: number; name: string }[]);
